<style lang="scss">
.remark-timeline-div{
    max-height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
}
.item-sku-change{
    cursor: pointer;
    color: #409EFF;
}
.remark-timeline-retrun {
    margin: 10px;
}

.item-sku-add {
    color: #67C23A;
}

.item-sku-del {
    color: #F56C6C;
}

.item-sku-up {
    color: #409EFF;
}
.item-sku-del-exp {
    float: right;
    margin-left: 5px;

    div {
        float: left;
        width: 20px;
        height: 20px;
    }

    .add {
        background-color: #67C23A;
    }

    .del {
        background-color: #F56C6C;
    }

    .up {
        background-color: #409EFF;
    }
}

.has-change-row {
    background-color: #F56C6C!important;
}

</style>

<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="params.type" clearable placeholder="类型" class="search-item">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.statusArr" multiple collapse-tags clearable placeholder="状态" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.productStatusArr" multiple collapse-tags clearable placeholder="生产状态" class="search-item">
                    <el-option
                        v-for="item in productStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.paymentStatusArr" multiple collapse-tags clearable placeholder="支付状态" class="search-item">
                    <el-option
                        v-for="item in paymentStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <sn-user-search-input
                    v-if="excludeFields.indexOf('creator') == -1"
                    class="search-item"
                    @change="
                (a) => {
                    params.creator = a;
                }
                "
                    title="请输入创建者名称"
                ></sn-user-search-input>

                <el-button
                    class="add-button"
                    type="success"
                    plain
                    icon="el-icon-plus"
                    size="small"
                    title="新增"
                    @click="showEditDialog()"
                    v-if="canAdd"
                ></el-button>

                <el-input
                    v-model="params.fullName"
                    placeholder="客户名称"
                    class="search-item"
                    clearable
                ></el-input>
            </el-row>

            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="创建时间（开始）"
                    v-model="params.createDateStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="创建时间（截止）"
                    v-model="params.createDateEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="期望交付时间（开始）"
                    v-model="params.deliveryTimeStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="期望交付时间（截止）"
                    v-model="params.deliveryTimeEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-input
                    v-if="excludeFields.indexOf('supplierName') == -1"
                    v-model="params.supplierName"
                    placeholder="供应商名称"
                    class="search-item"
                    clearable
                ></el-input>

                <el-button type="primary" size="small" @click="search(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="orders"
            stripe
            style="width: 100%"
            :height="height"
            class="factory-order-table"
            :row-class-name="tableRowClassName"
            @sort-change="sortChange"
        >
            <el-table-column prop="id" label="编号" width="180"></el-table-column>

            <el-table-column v-if="excludeFields.indexOf('amount') == -1" label="订单金额￥" width="100">
                <template slot-scope="order">{{ $tools.parsecost(order.row.amount)}}</template>
            </el-table-column>

            <el-table-column v-if="excludeFields.indexOf('paymentAmount') == -1" label="支付金额￥" width="100">
                <template slot-scope="order">
                    <span v-if="!order.row.paymentAmount || order.row.paymentAmount <= 0">0</span>
                    <span v-else><el-link @click="showPayment(order.row.id)" v-if="order.row.paymentAmount > 0" type="primary">{{ $tools.parsecost(order.row.paymentAmount)}}</el-link></span>
                </template>
            </el-table-column>

            <el-table-column prop="type" label="类型" width="65">
                <template slot-scope="order">
                    <el-tag size="small" v-if="order.row.type == 'S'" type="info">样品</el-tag>
                    <el-tag size="small" v-if="order.row.type == 'F'" type="success">大货</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="订单状态" width="100">
                <template slot-scope="order">
                    <el-tag size="small">{{getStatusTag(order.row.status, status)}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column v-if="excludeFields.indexOf('paymentStatus') == -1"  prop="status" label="支付状态" width="100">
                <template slot-scope="order">
                    <el-tag size="small" type="warning">{{getStatusTag(order.row.paymentStatus, paymentStatus)}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="生产状态" width="100">
                <template slot-scope="order">
                    <el-tag size="small" type="success">{{getStatusTag(order.row.productStatus, productStatus)}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="期望交付日期" width="120" sortable="custom" prop="DELIVERY_TIME">
                <template slot-scope="order">{{ $tools.timestampToDay(order.row.deliveryTime)}}</template>
            </el-table-column>
            <el-table-column label="计划交付日期" width="120" sortable="custom" prop="PLAN_DELIVERY_TIME">
                <template slot-scope="order">{{ $tools.timestampToDay(order.row.planDeliveryTime)}}</template>
            </el-table-column>
            <el-table-column label="实际交付日期" width="120" sortable="custom" prop="REAL_DELIVERY_TIME">
                <template slot-scope="order">{{ $tools.timestampToDay(order.row.realDeliveryTime)}}</template>
            </el-table-column>

            <el-table-column v-if="excludeFields.indexOf('supplierName') == -1" prop="supplierName" label="供应商" width="150"></el-table-column>

            <el-table-column prop="fullName" label="客户名称" width="300"></el-table-column>
            <el-table-column prop="companyName" label="公司名称" width="300"></el-table-column>
            
            <el-table-column v-if="excludeFields.indexOf('creator') == -1" prop="creatorName" label="创建者" width="80"></el-table-column>
            <el-table-column label="创建时间" width="180" sortable="custom" prop="CREATE_TIME">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.createTime)}}</template>
            </el-table-column>
            <el-table-column prop="alibabaOrder" label="关联订单" width="200"></el-table-column>

            <el-table-column label="操作" width="50" fixed="right">
                <template slot-scope="order">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <i class="el-icon-setting el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="order.row.id + ',a'">订单记录</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('d') != -1"
                                :command="order.row.id + ',d'"
                            >订单明细</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('b') != -1 && order.row.status != 'END' && order.row.status != 'CANCEL' && order.row.status != 'TRAN'"
                                :command="order.row.id + ',b'"
                            >修改基本信息</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('c') != -1 && order.row.status != 'END' && order.row.status != 'CANCEL' && order.row.status != 'TRAN'"
                                :command="order.row.id + ',c'"
                            >修改订单明细</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('e') != -1 && (order.row.status == 'INT' || order.row.status == 'DIS')"
                                :command="order.row.id + ',e'"
                            >分配供应商</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('f') != -1 && order.row.status == 'PRD'"
                                :command="order.row.id + ',f'"
                                divided
                            >更新生产进度</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('g') != -1 && (order.row.status == 'DIS'|| order.row.status == 'PRD')"
                                :command="order.row.id + ',g'"
                                divided
                            >订单排产</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('h') != -1 && (order.row.status == 'TRAN' || order.row.status == 'PRD')"
                                :command="order.row.id + ',h'"
                            >完成订单</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('j') != -1 && hasChange(order.row) && order.row.status == 'PRD'"
                                :command="order.row.id + ',j'"
                            >确认变更</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('k') != -1 && (order.row.status == 'DIS'|| order.row.status == 'PRD')"
                                :command="order.row.id + ',k'"
                            >支付款项</el-dropdown-item>



                            <el-dropdown-item
                                v-if="rights.indexOf('m') != -1 && order.row.status != 'END' && order.row.status != 'CANCEL' && order.row.status != 'TRAN'"
                                :command="order.row.id + ',m'"
                            >填写报价</el-dropdown-item>

                            <el-dropdown-item
                                v-if="rights.indexOf('i') != -1 && order.row.status != 'CANCEL'"
                                :command="order.row.id + ',i'"
                                divided
                            >取消订单</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="search"
            :current-page.sync="params.current"
        ></el-pagination>

        <factory-order-add
            ref="orderAdd"
            :showAdd.sync="showAdd"
            :isRoot="isRoot"
            :actionFuc="actionFuc"
        ></factory-order-add>

        <el-dialog :title="remarkTitle" width="600px" :visible.sync="showRemark" class="order-remark-dialog">
            <div v-if="showChangeTable" class="remark-timeline-div">
                <el-row>
                    <el-col :span="16"><el-link icon="el-icon-d-arrow-left" type="primary" class="remark-timeline-retrun" @click="showChangeTable = false">返回</el-link></el-col>
                    <el-col :span="8">
                        <div class="item-sku-del-exp">
                            <div class="add"></div>新增
                        </div>
                        <div class="item-sku-del-exp">
                            <div class="del"></div>删除
                        </div>
                        <div class="item-sku-del-exp">
                            <div class="up"></div>修改
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-table :data="oldData" class="number-table" border stripe :height="395" :span-method="colorSpanMethod">
                            <el-table-column prop="color" label="颜色" width="87"></el-table-column>
                            <el-table-column prop="size" label="尺寸" width="87"></el-table-column>

                            <el-table-column  label="总数" width="80">
                                <template slot-scope="scope">
                                    <span :class="'item-sku-' + scope.row.class">{{scope.row.number}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="2">
                        <div style="transform: translateY(190px);position: relative;">   ==></div>
                    </el-col>
                    <el-col :span="11">
                        <el-table :data="newData" class="number-table" border stripe :height="395" :span-method="colorSpanMethod">
                            <el-table-column prop="color" label="颜色" width="87"></el-table-column>
                            <el-table-column prop="size" label="尺寸" width="87"></el-table-column>

                            <el-table-column  label="总数" width="80">
                                <template slot-scope="scope">
                                    <span :class="'item-sku-' + scope.row.class">{{scope.row.number}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
            <div v-else class="remark-timeline-div">
                <el-timeline :reverse="reverse">
                    <el-timeline-item placement="top" v-for="(remark, index) in remarks" :key="index" :timestamp="(remark.type == 'S' ? '' : remark.creatorName) + ' ' + $tools.timestampToTime(remark.createTime)">
                        <div v-if="remark.type == 'S'">数据内容无权限查看</div>
                        <div v-else-if="remark.type == 'A'">创建订单</div>
                        <div v-else-if="remark.type == 'U'">修改订单</div>
                        <div v-else-if="remark.type == 'AI'">新增订单明细</div>
                        <div v-else-if="remark.type == 'DI'">删除订单明细</div>
                        <div v-else-if="remark.type == 'UI'">修改订单明细</div>
                        <div v-else-if="remark.type == 'C'">确认变更</div>
                        <div v-if="remark.remark" style="white-space: pre-wrap;" v-html="remark.remark" @click="showChange"></div>
                    </el-timeline-item>
                </el-timeline>
            </div>

             <div slot="footer" class="dialog-footer" v-if="remarkType == 2">
                <el-button type="primary" size="small" class="op-button" @click="confirmChange">确认变更</el-button>
             </div>
        </el-dialog>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import FactoryOrderAdd from "./Factory-order-add.vue";

export default {
    components: { FactoryOrderAdd, SnUserSearchInput },
    props: {
        height: { type: Number, default: 500 },
        excludeFields: { type: String, default: "" },
        isRoot: { type: Boolean, default: false },
        rights: { type: String, default: "" },
        pageUrl: { type: String, default: "" },
        canAdd:  { type: Boolean, default: false },
    },

    data() {
        return {
            showAdd: false,
            orders: null,
            params: {},
            orderId: null,
            showRemark: false,
            remarkType: 1,
            remarkTitle: "",
            showChangeTable: false,
            remarks: {},
            
            types: [
                { name: "样板", id: "S" },
                { name: "大货", id: "F" },
            ],
            status: [
                { id: "INT", name: "未操作" },
                { id: "DIS", name: "已分配供应商" },
                { id: "PRD", name: "生产中" },
                { id: "END", name: "订单完成" },
                { id: "CANCEL", name: "已取消" },
            ],
            paymentStatus: [
                { id: "INT", name: "未支付" },
                { id: "DOWN", name: "已付首款" },
                { id: "BALANCE", name: "已付尾款" }
            ],
            productStatus: [
                { id: "INT", name: "未启动" },
                { id: "PUR", name: "采购面料" },
                { id: "ACC", name: "辅料生产" },
                { id: "CUT", name: "裁片" },
                { id: "PRI", name: "印花" },
                { id: "SEW", name: "车缝" },
                { id: "LAB", name: "车标" },
                { id: "THR", name: "剪线头" },
                { id: "IRO", name: "熨烫" },
                { id: "PACK", name: "包装" },
            ],
            oldData: null,
            newData: null
        };
    },
    methods: {
        actionFuc() {
            this.search();
        },
        search(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            if (_this.params.statusArr) {
                _this.params.status = _this.params.statusArr.join(",")
            }

            if (_this.params.paymentStatusArr) {
                _this.params.paymentStatus = _this.params.paymentStatusArr.join(",")
            }

            if (_this.params.productStatusArr) {
                _this.params.productStatus = _this.params.productStatusArr.join(",")
            }

            _this.$http.post(
                [_this.getSearchUrl(), _this.params],
                [
                    function (data) {
                        _this.orders = data.records;
                        _this.params.pages = data.pages;
                        _this.params.total = data.total;
                        _this.params.current = data.current;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        getSearchUrl() {
            if (this.pageUrl) {
                return this.pageUrl;
            } else if (this.isRoot) {
                return "factory/order/page";
            } else {
                return "factory/order/mypage";
            }
        },
        handleCommand(command) {
            let id = command.split(",")[0];
            command = command.split(",")[1];

            if (
                command == "b" ||
                command == "c" ||
                command == "d" ||
                command == "e" ||
                command == "i" ||
                command == "f" ||
                command == "h" ||
                command == "g" ||
                command == "k" ||
                command == "m"
            ) {
                this.showEditDialog(id, command);
            } else if (command == "a") {
                this.getRemark(id);
            }  else if (command == "j") {
                this.getChange(id);
            } 
        },
        showEditDialog(id, type) {
            this.$refs["orderAdd"].show(id, type);
        },
        getStatusTag(id, status) {
            for (var i in status) {
                if (status[i].id == id) {
                    return status[i].name;
                }
            }
            return "状态错误";
        },
        getRemark(id) {
            let _this = this;

            _this.$http.post(
                [this.isRoot ? "factory/order/remark/get" : "factory/order/remark/myself" , {orderId: id}],
                [
                    function (data) {
                        _this.remarkTitle = "订单记录"
                        _this.remarkType = 1;
                        _this.remarks = data;
                        _this.showRemark = true;
                    },
                ],
                ".order-remark-dialog"
            );
        },
        getChange(id) {
            let _this = this;

            _this.$http.post(
                ["factory/order/remark/getChange" , {orderId: id}],
                [
                    function (data) {
                        _this.orderId = id;
                        _this.remarkTitle = "待确认变更"
                        _this.remarkType = 2;
                        _this.remarks = data;
                        _this.showRemark = true;
                    },
                ],
                ".order-remark-dialog"
            );
        },
        showChange(e)  {
            if (e.target.nodeName.toLowerCase() === 'span') {
                this.showChangeTable = true;

                try {
                    this.oldData = JSON.parse(e.target.dataset.item)[0];
                    this.newData = JSON.parse(e.target.dataset.item)[1];

                    let oldCache = {};
                    let oldSize = {};
                    for (var i in this.oldData) {
                        oldCache[this.oldData[i].color + "-" + this.oldData[i].size] = this.oldData[i].number;
                        oldSize[this.oldData[i].size] = 1;
                    }

                    let newCache = {};
                    let newSize = {};
                    for (var i in this.newData) {
                        newCache[this.newData[i].color + "-" + this.newData[i].size] = this.newData[i].number;
                        newSize[this.newData[i].size] = 1;
                    }

                    for (var i in this.oldData) {
                        if (!newCache[this.oldData[i].color + "-" + this.oldData[i].size]) {
                            this.oldData[i].class = "del";
                        }

                        this.oldData[i].rowspan = Object.getOwnPropertyNames(oldSize).length;
                    }

                    for (var i in this.newData) {
                        var id = this.newData[i].color + "-" + this.newData[i].size;

                        if (!oldCache[id] && oldCache[id] != 0) {
                            this.newData[i].class = "add";
                        } else if (this.newData[i].number != oldCache[id])  {
                            this.newData[i].class = "up";
                        }

                        this.newData[i].rowspan = Object.getOwnPropertyNames(newSize).length;
                    }

                } catch (error) {
                    this.oldData = null;
                    this.newData = null;
                }
            }
        },
        colorSpanMethod({ row, column, rowIndex, columnIndex }) {
            var size = row.rowspan;

            if (columnIndex == 0 && size > 1) { 
                if (rowIndex % size == 0) {
                    return [size, 1]
                } else {
                    return [0, 0]
                }
            }
        },
        confirmChange() {
            let _this = this;
            _this.$tConfirm.show("请仔细阅读变更数据后,再点击确认！！！", function() {
                _this.$http.post(
                    ["factory/order/confirmChange" , {id: _this.orderId}],
                    [
                        function (data) {
                            _this.showRemark = false;
                            _this.search();
                        },
                    ],
                    ".order-remark-dialog"
                );
            })
        },
        hasChange(order) {
            return order.changeTime && (!order.confirmTime || order.changeTime > order.confirmTime);
        },
        tableRowClassName({row, rowIndex}) {
            if (this.hasChange(row)) {
                return "has-change-row"
            }

            return "";
        },
        sortChange(column, prop, order) {
            this.params.sortName= column.prop
            this.params.sortOrder= column.order ? column.order == "ascending" ? "ASC" : "DESC" : "";
            this.search(1);
        },
        showPayment(id) {
            this.showEditDialog(id, 'l');
        }
    },
    mounted() {
        this.search(1);
    },
};
</script>